import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PreRegistration,ClonePreRegistration,ClonePreRegistrationUcid, ResponseCodePreRegistration  } from '../models/pre-registration.model';
import { ApiResponse, ResponseStatus, PayloadResponse  } from '../models/response.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class FormPreRegistrationService {

  private lineServiceUrl: string = environment.endpointBackend + '/api/line';

  constructor(private http: HttpClient) { }


  // allow for pre-registration
  apiPreRegistration(payload: PreRegistration): Observable<PayloadResponse<null>>{
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/insert/pre-registration', payload)
    .pipe(
      map(
        result => result.response_code === ResponseStatus.SUCCESS  ?  result.payload as PayloadResponse<null> : null
      )
    )
  }

  apiClonePreRegistration(payload: ClonePreRegistration): Observable<PayloadResponse<null>>{
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/insert/clonePre-registration', payload)
    .pipe(
      map(
        result => result.response_code === ResponseStatus.SUCCESS  ?  result.payload as PayloadResponse<null> : null
      )
    )
  }

  apiClonePreRegistrationUcid(payload: ClonePreRegistrationUcid): Observable<PayloadResponse<null>>{
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/insert/clonePre-registrationUcid', payload)
    .pipe(
      map(
        result => result.response_code === ResponseStatus.SUCCESS  ?  result.payload as PayloadResponse<null> : null
      )
    )
  }

}
